/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpackamountlabel3Inputs */

const en_creditpackamountlabel3 = /** @type {(inputs: Creditpackamountlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount of credits`)
};

const de_creditpackamountlabel3 = /** @type {(inputs: Creditpackamountlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge an Credits`)
};

/**
* | output |
* | --- |
* | "Amount of credits" |
*
* @param {Creditpackamountlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpackamountlabel3 = /** @type {((inputs?: Creditpackamountlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpackamountlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpackamountlabel3(inputs)
	return de_creditpackamountlabel3(inputs)
});
export { creditpackamountlabel3 as "creditPackAmountLabel" }